
jQuery.extend({
	getQueryParameters : function(str) {
		'use strict';
		if (document.location.search==='') return {};
		return (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this}.bind({}))[0];
	},
	ajaxDownload : function(url, data, options) {
		'use strict';
		var defaults = {
			id: 'ajaxDownloadFrame',
			name: 'request',
			method: 'POST',
			enctype: 'multipart/form-data'
		};
		options = $.extend(defaults, options);

		if (!url) {
			throw new Error('$.ajaxDownload(url,data,options) - invalid url');
		} else {
			var $iframe,iframe_doc,iframe_html;

			if (($iframe = $('#'+options.id)).length === 0) {
				$iframe = $('<iframe id="'+options.id+'" style="display: none" src="about:blank"></iframe>').appendTo("body");
			}

			iframe_doc = $iframe[0].contentWindow || $iframe[0].contentDocument;
			if (iframe_doc.document) iframe_doc = iframe_doc.document;
			iframe_html = '<html><head></head><body><form method="'+options.method+'" enctype="'+options.enctype+'" action="'+url+'">'+
						  '<input type="hidden" name="'+options.name+'" value=\''+JSON.stringify(data)+'\'>'+
						  '</form></body></html>';

			iframe_doc.open();
			iframe_doc.write(iframe_html);
			$(iframe_doc).find('form').submit();
		}
	},
	getGo: function(params, url) {
		'use strict';
		url = typeof url !== 'undefined' ? url : document.location.pathname;
		document.location = url + '?' + $.param(params);
	},
	postGo: function(params, url) {
		'use strict';
		url = typeof url !== 'undefined' ? url : document.location.href;
		var $form = $("<form>")
			.attr("method", "post")
			.attr("action", url)
			.css('display','none');
		$.each(params, function(name, value) {
			$("<input type='hidden'>")
				.attr("name", name)
				.attr("value", value)
				.appendTo($form);
		});
		$form.appendTo("body");
		$form.submit();
	}
});


/* Function to create a conFirm Dialog */
function confirmDialog(element) {
	try {
		var message = $(element).data('confirm');
		var href = $(element).attr('href');
		var title = $(element).data('title');
		var yes = $(element).data('yes');
		var no = $(element).data('no');
		if (!message) {message = 'Are you sure?';}

		bootbox.dialog({
			message: message,
			title: title,
			buttons: {
				yes: {
					label: yes,
					className: 'btn-primary',
					callback: function() {
						window.location = href;
					}
				},
				no: {
					label: no,
					className: 'btn-default'
				}
			}
		});
	} catch (e) {errorcallback(e);}
}

/**
 * $.serializeObject
 */
$.fn.serializeObject = function() {
	var o = {};
	var a = this.serializeArray();
	$.each(a, function() {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		} else {
			o[this.name] = this.value || '';
		}
	});
	return o;
};


/**
 * $.filterdropdown
 * (re)filter a dropdownlist
 *
 * usage: $('selector').filterdropdown('key','value');
 *		$('#district').filterdropdown('province',1);
 * Author: Jeroen de Jong (deJong-IT)
 */
$.fn.filterdropdown = function (key,value) {

	return this.each(function(index) {
		// store options in dataobject
		var options = $(this).data('options');
		// no need to continue if we already have the options
		if (options===undefined) {
			// store options for later use
			options = $('option',this).clone(true);
			$(this).data('options', options);
		}

		// Save current value for restore
		var currentvalue = $(this).val();
		var currentkey = $('option:selected',this).data(key);

		// remove all options
		$('option:not(:first)',this).remove();

		// filter options
		options.filter(function (idx, el) {
			return ($(this).data(key) == value);
		}).appendTo(this);//add it to list
		// reset the value

		if (currentkey == value) {
			$(this).val(currentvalue);
		} else {
			$('option:first',this).attr('selected', 'selected');
		}

		$(this).change();

	});
};

/**
 * $.sortdropdown
 * (re)order a dropdownlist
 *
 * usage: $('select').sortdropdown();
 * Author: Jeroen de Jong (deJong-IT)
 * options:
 *   skipfirst		Skip first (default: auto)
 *   order			Sort order (default: asc)
 *   caseinsensitive  Case insensitive check (default: true)
 */
$.fn.sortdropdown = function (options) {
	var defaults = {
		skipfirst: 'auto',
		order : 'asc',
		caseinsensitive : true
	};
	options = $.extend(defaults, options);

	return this.each(function () {

		// Keep track of the selected option.
		var selectedvalue = $(this).val();

		// Check if we need to skip the first based on the value (0/false/null/empty = skip)
		if (options.skipfirst==='auto') {
			var first = $('option:first',$(this)).val();
			skipfirst = (first) ? false:true;
		} else {
			skipfirst = options.skipfirst;
		}

		// we need to skip the first (select xxx)
		if (skipfirst) {
			var firstoption = $('option:first',$(this));
			var alloptions = $('option:not(:first)', $(this));
		} else {
			var alloptions = $('option', $(this));
		}

		// Check if we need to sort ascending or descending
		if (options.order=='asc') {
			var order1 = -1;
			var order2 = 1;
		} else {
			var order1 = 1;
			var order2 = -1;
		}

		// Sort all the options by text.
		var sortoptions = alloptions.get().sort(function(a, b) {
			if (options.caseinsensitive) {
				var x = jQuery(a).text().toUpperCase();
				var y = jQuery(b).text().toUpperCase();
			} else {
				var x = jQuery(a).text();
				var y = jQuery(b).text();
			}

			return x == y ? 0 : x < y ? order1 : order2;
		});

		// Prepend the first if needed
		if (skipfirst) {
			$(this).html(sortoptions).prepend(firstoption);
		} else {
			$(this).html(sortoptions);
		}

		// Select the original value
		$(this).val(selectedvalue);

	});
};

/**
 * $.random
 * give a random number between m and n
 *
 * usage: $.random(100,999);
 * Author: Jeroen de Jong (deJong-IT)
 * options:
 *   m			  minimum number
 *   n			  maximum number
 */
jQuery.random = function(m,n) {
	m = parseInt(m,10);
	n = parseInt(n,10);
	return Math.floor( Math.random() * (n - m + 1) ) + m;
};
